angular.module("Main").directive("aggregatorWizard", wizzard);

function wizzard() {
    return {
        templateUrl: "./app/Main/controls/bookingWizard/aggregatorWizard.html",
        restrict: "EA",
        controller: BookingWizardController,
        controllerAs: "vm",
        scope: true,
        link: function (scope, element, attrs) {
            scope.active = scope.$eval(attrs.active);
            scope.clubId = scope.$eval(attrs.clubId);
        }
    };
}

BookingWizardController.$inject = ["$scope", "$rootScope", "$location", "$uibModal", "$translate", "tmhDynamicLocale", "$localStorage", "LANGUAGES", "$stateParams", "$state", "SessionService", "BookingService"];

function BookingWizardController($scope, $rootScope, $location, $uibModal, $translate, tmhDynamicLocale, $localStorage, LANGUAGES, $stateParams, $state, SessionService, BookingService) {
    var vm = this;

    if (_.isEmpty($stateParams.club)) {
        vm.withoutClubsMenuItem = false;
    } else {
        vm.withoutClubsMenuItem = true;
        $state.go('aggregator_overview', {sid: SessionService.getSessionId(), cid: $stateParams.cid, id: $stateParams.id});
    }
    vm.openedMenuBar = false;

    if (screen.width < 600) {
        vm.isMobilePhone = true;
    } else {
        vm.isMobilePhone = false;
    }

    init();
    loadLayoutConfiguration();
    getLocalStorageLoginData();

        vm.cookies = SessionService.checkSession();

    function getLocalStorageLoginData() {
        if (!_.isNil($localStorage.user) && !_.isUndefined($localStorage.user.username)) {
            vm.isLoggedIn = true;
            vm.username = $localStorage.user.username;
        }
    }

    vm.goto = function (step) {

        vm.openedMenuBar = false;
        var clubId = $scope.$parent.$resolve.$stateParams.cid;
        if ($scope.active === 3 || $scope.active === 4) {
            if (step === 1)
                $state.go('aggregator_clubs', {cid: $stateParams.cid, id: $stateParams.id});
            if (step === 2)
                $state.go("aggregator_overview", {cid: clubId, id: $stateParams.id});
        }
        if( $scope.active === 4 && step === 3) {
            $state.go('aggregator_register', {cid: $stateParams.cid, id: $stateParams.id});
        }
        if($scope.active === 5 && step === 1) {
            $state.go('aggregator_clubs', {cid: $stateParams.cid, id: $stateParams.id});
        } else if ($scope.active === 2 && step === 1)
            $state.go('aggregator_clubs', {cid: $stateParams.cid, id: $stateParams.id});
    }

    vm.openMenuBar = function () {
        if (vm.openedMenuBar === false) {
            vm.openedMenuBar = true;
        } else {
            vm.openedMenuBar = false;
        }
    };

    function getLocalStorageLanguage() {
        if (_.isNil($localStorage.currentLanguage))
            $localStorage.currentLanguage = _.first(LANGUAGES);

        return $localStorage.currentLanguage;
    }

    function init() {
        vm.isApp = SessionService.isApp();
        if (vm.isApp) {
            vm.currentLanguage = getLocalStorageLanguage();
            tmhDynamicLocale.set(vm.currentLanguage.lang);
            $translate.use(vm.currentLanguage.lang);
        }
    }

    function loadLayoutConfiguration() {
        BookingService.loadLayoutConfiguration().then(function (data) {
            vm.layoutSettings = angular.fromJson(data.Layout);
        })
    }
}